/**
 * @fileoverview GET handler for the "/engagement/segments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegments } from "./constants";
import type { EngagementSegmentsParams, SegmentsListResult } from "./types";
import { formatParams } from "./utils";

export const getEngagementSegments = reactQueryTableFetcherAdapter(
  engagementSegments,
  (signal: AbortSignal, params: EngagementSegmentsParams): Promise<SegmentsListResult> => {
    return fetch("/engagement/segments", "GET", formatParams(params), { signal });
  }
);
